
import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const Accessibilite = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Accessibilité - Groupe Fabre Environnement"
        description="Déclaration d'accessibilité du site Groupe Fabre Environnement"
        canonical="/accessibilite"
      />
      
      <Navbar />
      
      <main className="flex-1 pt-20">
        <div className="container mx-auto px-4 py-12">
          <h1 className="text-4xl font-bold text-fabre-gray mb-8">Accessibilité</h1>
          <div className="prose max-w-none">
            <p className="text-lg text-gray-600 mb-6">
              Groupe Fabre Environnement s'engage à rendre son site web accessible à tous les utilisateurs.
            </p>
            
            <h2 className="text-2xl font-semibold text-fabre-darkgreen mb-4">
              Déclaration d'accessibilité
            </h2>
            <p className="mb-4">
              Cette déclaration d'accessibilité s'applique au site web de Groupe Fabre Environnement.
              Nous nous efforçons de respecter les standards d'accessibilité pour permettre à tous 
              les utilisateurs d'accéder facilement à nos contenus et services.
            </p>
            
            <h2 className="text-2xl font-semibold text-fabre-darkgreen mb-4">
              Contact
            </h2>
            <p>
              Si vous rencontrez des difficultés d'accessibilité sur notre site, 
              n'hésitez pas à nous contacter au 05 65 78 79 00 ou par email à contactgfe@groupefabre.com
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Accessibilite;
